import React from 'react';
import { bool, func, object, number } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { isRecurringGig } from '../../../../reducers/packages';
import { shouldShowSelectPackage } from '../../../../utils/shouldShowSelectPackage';
import { inMobileStickyExperience } from '../../../../utils/experiments/mobileStickyCta';
import { VARIANTS } from '../../../../types/variants';
import CheckoutPlans from './CheckoutPlans';
import CompareBtn from './CompareBtn';
import CtaBtn from './CtaBtn';

import './style.scss';

const TabFooter = ({
    showCompareAnchor = true,
    currentPrice,
    isRecurringGig,
    onComparePackagesClick
}, { general, currencyConverter }) => {
    const context = getContext();
    const showSelectPackage = shouldShowSelectPackage(general);
    const formattedPrice = currencyConverter.convert(currentPrice);

    if (!showSelectPackage && !showCompareAnchor && !isRecurringGig) {
        return null;
    }

    const wrapperClass = classNames(
        'tab-footer',
        { 'recurring-gig': isRecurringGig }
    );
    const ctaBtnClass = classNames({
        'mobile-sticky-experience': inMobileStickyExperience({ context, general, variations: [VARIANTS.B] })
    });

    return (
        <footer className={wrapperClass}>
            {isRecurringGig && <CheckoutPlans/>}
            {showSelectPackage && <CtaBtn className={ctaBtnClass} price={formattedPrice}/>}
            {showCompareAnchor && <CompareBtn onComparePackagesClick={onComparePackagesClick}/>}
        </footer>
    );
};

TabFooter.propTypes = {
    showCompareAnchor: bool,
    currentPrice: number,
    onComparePackagesClick: func
};

TabFooter.contextTypes = {
    general: object,
    currencyConverter: object
};

const mapStateToProps = ({ packages }) => ({
    isRecurringGig: isRecurringGig(packages)
});

export { TabFooter };
export default connect(mapStateToProps)(TabFooter);
